import React from "react";

interface QuestionProgressProps {
  currentIndex: number;
  totalQuestions: number;
}

export default function QuestionProgress({
  currentIndex,
  totalQuestions,
}: QuestionProgressProps) {
  const progressPercentage = ((currentIndex + 1) / totalQuestions) * 100;

  return (
    <>
      <div className="progress-text">
        Question {currentIndex + 1} of {totalQuestions}
      </div>
      <div className="progress-bar-wrapper">
        {/* Progress text */}

        {/* Progress bar container */}
        <div className="progress-bar-container">
          {/* Progress fill */}
          <div
            style={{
              height: "100%",
              width: `${progressPercentage}%`,
              backgroundColor: "#FF8C4B",
              transition: "width 0.3s ease",
            }}
          />
        </div>
      </div>
    </>
  );
}
